import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { handleShowModal } from 'components/global/_helpers/global.helpers';
import PageTitle from 'components/global/PageTitle/PageTitle';
import { Button } from 'react-bootstrap';
import { useEffectAsync } from 'utils/useEffectAsync';
import { fetchAndSetInvestorOptionsData } from 'components/views/InvestorDealflow/_helpers/investorDealflow.resolvers';
import InvestorDealflowBoard from 'components/views/InvestorDealflow/_components/InvestorDealflowBoard';
import InvestorCreateDealFlowModal from 'components/views/InvestorDealflow/_components/InvestorCreateDealflowModal';
import withDismount from 'hocs/withDismount';

const InvestorInvestorsList = () => {
  useEffectAsync(fetchAndSetInvestorOptionsData, []);
  return (
    <>
      <PageTitle Buttons={(
        <Button className="me-16 text-info border-dark bg-dark" variant="transparent" size="sm" onClick={() => handleShowModal('investor-dealflow-create')}>
          <FontAwesomeIcon icon={faPlus} className="me-8" size="sm" />
          Add to DealFlow
        </Button>
      )}
      >
        Deal Flow
      </PageTitle>
      <InvestorDealflowBoard />
      <InvestorCreateDealFlowModal />
    </>
  );
};

export default withDismount(InvestorInvestorsList);
